import React from 'react';
import { getModelsForAgent } from '../../../constants/aiModels';
import './ModelSelect.css';

const ModelSelect = ({ aiAgent = 'claude', value, onChange, disabled = false, label }) => {
  const models = getModelsForAgent(aiAgent);
  // No value ⇒ the select opens on the placeholder. Coercing to a per-vendor
  // default here made the submitted value look like a deliberate choice.
  const currentValue = value || '';

  return (
    <div className="model-select-wrapper">
      {label && <label className="model-select-label">{label}</label>}
      <select
        value={currentValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="model-select"
      >
        <option value="" disabled>Set a model</option>
        {models.map((m) => (
          <option key={m.id} value={m.id}>{m.name}</option>
        ))}
      </select>
    </div>
  );
};

export default ModelSelect;
